import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const usePurchaseOrdersLdFlags = createFlagsHook<typeof import('./flags.json')>()
